<template>
  <div v-if="sortedVisits.length">
    <visit-history 
      v-for="visit in sortedVisits"
      :key="visit.id"
      :visit="visit"
      :packages="packages"
    />
  </div>
  <div v-else>
    <div class="ui placeholder segment" style="margin-bottom: 50px">
      <div class="ui icon header" style="color: #092442">
        <i class="dont icon"></i>
        There is No medical history for this patient.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    visitHistory: require('./visit_history_components/VisitHistory').default
  },
  props: {
    visits: { type: Array, required: true },
    packages: { type: Array, required: true }
  },
  data() {
    return {};
  },
  computed: {
    sortedVisits () {
      return this.visits.sort((a, b) => {
        return new Date(b.started_at) - new Date(a.started_at) 
      })
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/PatientMedicalHistory.vue